import React from "react";

import VideoComponent from "../components/generics/videoComponent";
import ListComponent from "../components/generics/listComponent";
import HorizontalComponent from "../components/generics/horizontalComponent";
import ImageComponent from "../components/generics/imageComponent";

const news = [
  [
    "17 September 2026",
    <div>
      <VideoComponent src="https://www.youtube-nocookie.com/embed/ndUVM28-J-s" />
      <p>
        Jeremy Gibbons spoke to us about using streaming algorithms in Haskell
        to compute as many digits of π as your heart desires!
      </p>
    </div>,
  ],
  [
    "15 September 2026",
    <div>
      <VideoComponent src="https://www.youtube-nocookie.com/embed/4TRYc61pG-M" />
      <p>
        Yusuke Matsushita visited us in Bristol and gave an extended talk on his
        work with Hiromi Ishii on{" "}
        <a
          href="https://doi.org/10.1145/3808259"
          target="_blank"
          rel="noreferrer"
        >
          Pure Borrow
        </a>
        , which adds Rust-style borrowing to pure Haskell!
      </p>
    </div>,
  ],
  [
    "14 September 2026",
    <div>
      <div className="d-flex justify-content-center align-items-center">
        <ImageComponent
          alt={
            "PLRG group members smiling and posing in front of their beautiful cakes."
          }
          src={"images/news/bake-it-group-photo.jpg"}
          maxHeight="315px"
        />
      </div>
      <p>
        For Dr Sam's PhD celebration we went to{" "}
        <a
          href="https://www.bakeitbristol.com/"
          target="_blank"
          rel="noreferrer"
        >
          Bake It! Bristol
        </a>{" "}
        for a PLRG bake off.
      </p>
    </div>,
  ],
  [
    "1 September 2026",
    <div>
      <VideoComponent src="https://www.youtube-nocookie.com/embed/twKSuUbMH9A" />
      <p>
        The{" "}
        <a
          href="https://2025.splashcon.org/track/splash-2025-farm"
          target="_blank"
          rel="noreferrer"
        >
          FARM 2025
        </a>{" "}
        performance videos, filmed and edited by PLRG's Jessica Foster, have
        been released on YouTube. See the{" "}
        <a
          href="https://youtube.com/playlist?list=PLF5xDewoVNoc"
          target="_blank"
          rel="noreferrer"
        >
          full playlist here
        </a>
        . A big thank you to Mae Milano and FARM for funding Jess' trip to
        Singapore and the rental of (very nice) AV equipment!
      </p>
    </div>,
  ],
  [
    "August 2026",
    <div>
      Alex Wood is starting a PhD, co-funded by UKRI and Canonical, to
      investigate automated C to Rust translations, building on our{" "}
      <a
        href="https://doi.org/10.1145/3729315"
        target="_blank"
        rel="noreferrer"
      >
        previous research
      </a>{" "}
      <a
        href="https://doi.org/10.1007/978-3-031-37709-9_22"
        target="_blank"
        rel="noreferrer"
      >
        in this area
      </a>
      . This has drawn media attention from outlets like{" "}
      <a
        href="https://www.theregister.com/software/2026/08/24/canonical-backs-quest-to-translate-mountains-of-c-into-safe-rust-with-ai/5290959"
        target="_blank"
        rel="noreferrer"
      >
        The Register
      </a>{" "}
      and{" "}
      <a
        href="https://www.infoworld.com/article/4212147/canonical-and-uks-university-of-bristol-partner-to-investigate-automated-c-to-rust-translations.html"
        target="_blank"
        rel="noreferrer"
      >
        InfoWorld
      </a>
      . The project will be led by Canonical's Jon Seager and PLRG's Meng Wang
      and Cristina David. See{" "}
      <a
        href="https://discourse.ubuntu.com/t/investing-in-automated-c-to-rust-translation/86369"
        target="_blank"
        rel="noreferrer"
      >
        Jon's post about the project
      </a>{" "}
      for more details.
    </div>,
  ],
  [
    "August 2026",
    <div>
      April Tune and Alex Kavvos' paper '
      <a
        href="https://doi.org/10.1145/3828686"
        target="_blank"
        rel="noreferrer"
      >
        Bimodels and Biorthogonality for Abstract Machines
      </a>
      ' has been accepted at ICFP'26.
    </div>,
  ],
  [
    "31 July 2026",
    <div>
      <VideoComponent src="https://www.youtube-nocookie.com/embed/dyRiPJM4DNw" />
      <p>
        Sam's PLDI talk for{" "}
        <a
          href="https://doi.org/10.1145/3808269"
          target="_blank"
          rel="noreferrer"
        >
          Contextual Embedding
        </a>{" "}
        has been posted to the{" "}
        <a
          href="https://www.youtube.com/@acmsigplan"
          target="_blank"
          rel="noreferrer"
        >
          ACM SIGPLAN YouTube channel
        </a>
        !
      </p>
    </div>,
  ],
  [
    "21 July 2026",
    <div>
      <VideoComponent src="https://www.youtube-nocookie.com/embed/Vc2ninFboYY" />
      <p>
        We had the wonderful Conor Titania Mc Bride talk to us about a new twist
        on implementing Hindley-Milner type inference. Specifically, using the
        magic of effects to make bookkeeping disappear!
      </p>
    </div>,
  ],
  [
    "15 July 2026",
    <div>
      <VideoComponent src="https://www.youtube-nocookie.com/embed/2EZ71b8Jnhs" />
      <p>
        We've started a{" "}
        <a
          href="https://www.youtube.com/@PLRGBristol"
          target="_blank"
          rel="noreferrer"
        >
          YouTube channel
        </a>{" "}
        where we'll be uploading talks from some of the wonderful guest speakers
        who visit us in Bristol. Our first talk is 'Well-scoped de Bruijn
        expressions in Dependent Haskell' from Stephanie Weirich!
      </p>
    </div>,
  ],
  [
    "July 2026",
    <div>
      <div className="d-flex justify-content-center align-items-center">
        <ImageComponent
          alt={
            "Dr Meng Wang and Dr Samantha Frohlich dressed up in graduation robes and shaking hands."
          }
          src={"images/news/sam-grad.jpg"}
          maxHeight="315px"
        />
      </div>
      <p>Congratulations to Dr Samantha Frohlich on her graduation!</p>
    </div>,
  ],
  [
    "July 2026",
    <div>
      Meng Wang has joined the{" "}
      <a
        href="https://jfp.episciences.org/en/boards"
        target="_blank"
        rel="noreferrer"
      >
        board of the Journal of Functional Programming
      </a>{" "}
      as an editor.
    </div>,
  ],
  [
    "June 2026",
    "Sam Frohlich will serve on the OOPSLA and ICFP 2027 Program Committees.",
  ],
  [
    "15 June 2026",
    <div>
      <a
        href="https://haskell.foundation/podcast/83/"
        target="_blank"
        rel="noreferrer"
      >
        Part 2 of Jess' series of interviews at POPL 2026
      </a>{" "}
      has been published on the{" "}
      <a
        href="https://haskell.foundation/podcast/"
        target="_blank"
        rel="noreferrer"
      >
        Haskell Interlude podcast
      </a>
      , featuring our very own Eddie Jones and Tom Divers.
    </div>,
  ],
  [
    "13 April 2026",
    <div>
      <a
        href="https://haskell.foundation/podcast/80/"
        target="_blank"
        rel="noreferrer"
      >
        Part 1 of Jess' series of interviews at POPL 2026
      </a>{" "}
      has been published on the{" "}
      <a
        href="https://haskell.foundation/podcast/"
        target="_blank"
        rel="noreferrer"
      >
        Haskell Interlude podcast
      </a>
      .
    </div>,
  ],
  [
    "March 2026",
    <div>
      Meng is looking for two postdoctoral researchers to join the group to work
      on exciting challenges in programming languages. The posts offer the
      freedom to pursue research across a broad range of topics, along with
      excellent academic and financial support. Please get in touch if
      interested.
    </div>,
  ],
  [
    "March 2026",
    "Congratulations to Sam Frohlich on her appointment to Lecturer in Computer Science!",
  ],
  [
    "February 2026",
    <div>
      <div className="d-flex justify-content-center align-items-center">
        <ImageComponent
          alt={
            "Shot of S-REPLS 18 from the back of the room during Martin Lester's talk."
          }
          src={"images/news/s-repls18-crowd.jpg"}
          maxHeight="315px"
        />
      </div>
      <p>
        We hosted{" "}
        <a
          href="https://plrg-bristol.github.io/SREPLS18/"
          target="_blank"
          rel="noreferrer"
        >
          S-REPLS 18
        </a>{" "}
        at{" "}
        <a href="https://www.watershed.co.uk/" target="_blank" rel="noreferrer">
          Watershed
        </a>{" "}
        in Bristol! The event was a great success and featured keynote talks
        from{" "}
        <a
          href="https://www.soundandcomplete.org/"
          target="_blank"
          rel="noreferrer"
        >
          Azalea Raad
        </a>{" "}
        and{" "}
        <a href="https://cs.brown.edu/~sk/" target="_blank" rel="noreferrer">
          Shriram Krishnamurthi
        </a>
        .
      </p>
    </div>,
  ],
  [
    "February 2026",
    <div>
      Congratulations to Meng Wang on his project{" "}
      <i>Complex Semantics for Higher Order Abstract Syntax</i> which has been
      funded through the EPSRC Standard Mode.
    </div>,
  ],
  [
    "February 2026",
    <div>
      <div className="d-flex justify-content-center align-items-center">
        <ImageComponent
          alt={"Sam with her viva examiners."}
          src={"images/news/sam-viva.jpg"}
          maxHeight="315px"
        />
      </div>
      <p>
        Congratulations to Sam who passed her PhD viva with thesis title
        "Embedding Complex Languages in the Functional Programming Vernacular"!
      </p>
    </div>,
  ],
  [
    "January 2026",
    <div>
      <p>
        The group has two papers at POPL'26! Come to our talks to hear about the
        latest ideas in the semantics of functional logic programming and in
        type systems for bug-finding.
      </p>
      <ul>
        <li>
          <p>
            <a
              href="https://doi.org/10.1145/3776699"
              target="_blank"
              rel="noreferrer"
            >
              Domain-Theoretic Semantics for Functional Logic Programming
            </a>
            , by Eddie Jones, Samson Main, Celia Mengyue Li, Jonathan Marriott
            and Alex Kavvos.
          </p>
          <p>Wednesday 10:30 at Nef</p>
          <p>
            Functional Logic Programming (FLP) is a paradigm that extends
            higher-order functional programming with nondeterministic choice,
            logical variables, and equational constraints. Starting from the
            observation that these constructs can be presented as algebraic
            effects, we rationally reconstruct a core calculus for FLP that is
            based on call-by-push-value, and supports higher-order functions and
            recursion. We show how to execute its programs through an abstract
            machine that implements narrowing. Finally, we present a
            domain-theoretic semantics based on the lower powerdomain, which we
            prove to be sound, adequate, and fully abstract with respect to the
            machine. This leads to an exploration of the limitations of domain
            theory in modelling FLP.
          </p>
        </li>
        <li>
          <p>
            <a
              href="https://dl.acm.org/doi/10.1145/3776724"
              target="_blank"
              rel="noreferrer"
            >
              A Complementary Approach to Incorrectness Typing
            </a>
            , by Celia Mengyue Li, Sophie Pull and Steven Ramsay.
          </p>
          <p>Thursday 16:10 at Dortoirs</p>
          <p>
            We introduce a new two-sided type system for verifying the
            correctness and incorrectness of functional programs with atoms and
            pattern matching. A key idea in the work is that types should range
            over sets of normal forms, rather than sets of values, and this
            allows us to define a complement operator on types that acts as a
            negation on typing formulas. We show that the complement allows us
            to derive a wide range of refutation principles within the system,
            including the type-theoretic analogue of co-implication, and we use
            them to certify that a number of Erlang-like programs go wrong. An
            expressive axiomatisation of the complement operator via subtyping
            is shown decidable, and the type system as a whole is shown to be
            not only sound, but also complete for normal forms.
          </p>
        </li>
      </ul>
    </div>,
  ],
  [
    "November 2025",
    "Wenjia Ye has joined the group as a senior research associate, after a PhD from University of Hong Kong and a PostDoc stint at National University of Singapore. She will be working on gradual typing for Rust with Meng Wang and Cristina David.",
  ],
  [
    "29 October 2025",
    <div>
      <div className="d-flex justify-content-center align-items-center">
        <ImageComponent
          alt={
            "14 of us, PLRG members and undergrads, posing for a group photo at AWS headquarters in London. There is remarkably little agreement about what poses and faces to adopt."
          }
          src={"images/news/S-REPLS17-group-photo.jpg"}
          maxHeight="315px"
        />
      </div>
      <p>
        We showed up in force to{" "}
        <a
          href="https://aws-experience.com/emea/uki/e/70859/s-repls"
          target="_blank"
          rel="noreferrer"
        >
          S-REPLS 17
        </a>
        , along with many enthusiastic undergrads! Cristina (who had to leave
        before we could take the photo) gave a talk on automating translation of
        real-world codebases.
      </p>
    </div>,
  ],
  [
    "October 2025",
    "5 new PhD students started in the group. Welcome Henrijs Princis, Samson Main, Amos Holland, Weilin He, and Liqiang Shang!",
  ],
  [
    "October 2025",
    <div>
      Jess, Alex, and Roly attending ICFP/SPLASH25 in Singapore. Jess filmed the
      FARM performance (expect the edited videos to be published some time next
      year!), Alex gave a talk at OOPSLA (
      <a
        href="https://2025.splashcon.org/details/OOPSLA/46/Adequacy-for-Algebraic-Effects-Revisited"
        target="_blank"
        rel="noreferrer"
      >
        Adequacy for Algebraic Effects Revisited
      </a>
      ), and Roly gave a talk at PROPL (
      <a
        href="https://conf.researchr.org/details/icfp-splash-2025/propl-2025-papers/10/Authoring-Tools-for-Transparent-Climate-Reporting"
        target="_blank"
        rel="noreferrer"
      >
        Authoring Tools for Transparent Climate Reporting
      </a>
      ).
    </div>,
  ],
  [
    "August 2025",
    <div>
      <div className="d-flex justify-content-center align-items-center">
        <ImageComponent
          alt={
            "Sam with a large group of friendly people at the EHOP workshop 2025"
          }
          src={"images/news/ehop-workshop-2025.jpg"}
          maxHeight="315px"
        />
      </div>
      <p>
        Sam had a great time at the{" "}
        <a
          href="https://effect-handlers.org/events/ehop-workshop2025.html"
          target="_blank"
          rel="noreferrer"
        >
          EHOP Workshop 2025
        </a>
        .
      </p>
    </div>,
  ],
  [
    "August 2025",
    <div>
      Two proposals from the group, "Secure Code Generation with Large Language
      Models" (Arindam Sharma and Cristina David) and "Relational Dualities for
      Program Logics" (Alex Kavvos), have been accepted for funding by the{" "}
      <a href="https://vetss.org.uk/" target="_blank" rel="noreferrer">
        Research Institute in Verified Trustworthy Software Systems (VeTSS)
      </a>
      .
    </div>,
  ],
  ["August 2025", "Meng will be serving on the PLDI 2026 program committee."],
  [
    "August 2025",
    "Yoav Alon has passed his PhD defence with the thesis 'Neural Reasoning For Program Analysis' Congratulations Yoav!",
  ],
  [
    "June 2025",
    <div>
      <div className="d-flex justify-content-center align-items-center">
        <ImageComponent
          alt={
            "Hanliang presenting 'Scalable, Validated Code Translation of Entire Projects using LLMs' at PLDI 2025 in Seoul."
          }
          src={"images/news/hanliang-PLDI-2025.jpg"}
          maxHeight="315px"
        />
      </div>
      <p>
        Hanliang presenting our recent work on translating entire code
        repositories to Rust at PLDI 2025. (
        <a
          href="https://dl.acm.org/doi/abs/10.1145/3729315"
          target="_blank"
          rel="noreferrer"
        >
          Paper
        </a>
        ,{" "}
        <a
          href="https://www.youtube.com/watch?v=7M9KHvbOL3U"
          target="_blank"
          rel="noreferrer"
        >
          Video
        </a>
        ). This marks a significant milestone in our ongoing collaboration with
        Amazon.
      </p>
    </div>,
  ],
  [
    "May 2025",
    <div>
      <div className="d-flex justify-content-center align-items-center">
        <ImageComponent
          alt={"Nicola Assolini giving a talk to the PLRG"}
          src={"images/news/nicola-assolini-may-2025.jpg"}
          maxHeight="315px"
        />
      </div>
      <p>
        <a
          href="https://nicolaassolini98.github.io/"
          target="_blank"
          rel="noreferrer"
        >
          Nicola Assolini
        </a>{" "}
        visited us from the University of Verona to work with us on embedded
        quantum programming languages in Haskell.
      </p>
    </div>,
  ],
  [
    "April 2025",
    <div>
      Alex Kavvos served on the{" "}
      <a
        href="https://icfp25.sigplan.org/committee/icfp-2025-papers-icfp-papers-and-events"
        target="_blank"
        rel="noreferrer"
      >
        ICFP 2025 Programme Committee
      </a>
      .
    </div>,
  ],
  [
    "April 2025",
    <div>
      Sam Frohlich will be presenting at the{" "}
      <a
        href="https://vetss.org.uk/event/vetss-annual-meeting-2025/"
        target="_blank"
        rel="noreferrer"
      >
        VeTSS Annual Meeting 2025
      </a>
      .
    </div>,
  ],
  [
    "March 2025",
    "Meng is now serving as the Steering Committee Chair for Partial Evaluation and Program Manipulation (PEPM).",
  ],
  [
    "March 2025",
    "Scalable, Validated Code Translation of Entire Projects using Large Language Models is (conditionally) accepted by PLDI.",
  ],
  [
    "February 2025",
    <div>
      We are recruiting a Senior Research Associate in Programming Languages.{" "}
      <a
        href="https://www.bristol.ac.uk/jobs/find/details/?jobId=372879"
        target="_blank"
        rel="noreferrer"
      >
        Click here to find more details and apply.
      </a>{" "}
      Deadline: 26th March.
    </div>,
  ],
  [
    "February 2025",
    "Eddie Jones will serve on the POPL 2026 program committee.",
  ],
  [
    "January 2025",
    "Joseph Bond, Cristina David, Minh Nguyen, Dominic Orchard, Roly Perera, 'Conjugate operators for transparent, explorable research outputs', accepted at ESOP'25",
  ],
  [
    "January 2025",
    "Henrijs Princis, Cristina David, Alan Mycroft, 'Enhancing SQL Query Generation with Neurosymbolic Reasoning', accepted at AAAI'25",
  ],
  [
    "January 2025",
    "Yoav Alon, Cristina David, 'Integrating Large Language Models and Reinforcement Learning for Non-Linear Reasoning', accepted at FSE'25",
  ],
  ["January 2025", "Cristina David will be on the committee of CAV'25"],
  [
    "October 2024",
    <div>
      Alex won an ARIA grant to study{" "}
      <a
        href="https://www.aria.org.uk/safeguarded-ai-creators/"
        target="_blank"
        rel="noreferrer"
      >
        Safeguarded AI
      </a>{" "}
      for his project "Two-dimensional Kripke Semantics and World Models".
    </div>,
  ],
  [
    "October 2024",
    <div>
      Alex is serving on the{" "}
      <a
        href="https://2025.splashcon.org/track/OOPSLA"
        target="_blank"
        rel="noreferrer"
      >
        OOPSLA 2025
      </a>{" "}
      committee.
    </div>,
  ],
  [
    "September 2024",
    <div>
      <div className="d-flex justify-content-center align-items-center">
        <ImageComponent
          alt={"Meng receiving distinguished paper award at ECOOP 2024."}
          src={"images/news/meng-ECOOP.jpg"}
          maxHeight="315px"
        />
      </div>
      <p>
        Meng received a distinguished paper award at ECOOP'24 for his paper{" "}
        <a
          href="https://doi.org/10.4230/LIPIcs.ECOOP.2024.39"
          target="_blank"
          rel="noreferrer"
        >
          Formalizing, Mechanizing, and Verifying Class-Based Refinement Types
        </a>{" "}
        in collaboration with Ke Sun, Di Wang, Sheng Chen, and Dan Hao.
      </p>
    </div>,
  ],
  [
    "September 2024",
    <div>
      Many of us went to ICFP'24 in Milan: Sam gave a talk at PLWM; Hanliang
      gave a talk at ICFP; Jess was part of the AV team and took the lead on
      filming the FARM performance.
    </div>,
  ],
  [
    "13-15 August 2024",
    <div>
      The group hosted the{" "}
      <a href="https://wp.doc.ic.ac.uk/vss24/" target="_blank" rel="noreferrer">
        2024 VeTSS Summer School
      </a>
      , which we're happy to say was a great success! A special thank you to
      Teresa and Azalea from Imperial, Ling and Brijesh from Surrey, and Ell
      from the CS school office for all their hard work.{/* </p> */}
    </div>,
  ],
  [
    "June 2022",
    <div>
      <VideoComponent src="https://www.youtube-nocookie.com/embed/GcN9YTYQDsA" />
      <p>
        Alex gave a talk on Two-Dimensional Kripke Semantics at{" "}
        <a href="https://oxford24.github.io/">MFPS 2024</a> in Oxford.
      </p>
    </div>,
  ],
  [
    "May 2024",
    <div>
      <div className="d-flex justify-content-center align-items-center">
        <ImageComponent
          alt={
            "Sam and Jess posing in front of a poster advertising their talks at Peking University."
          }
          src={"images/news/sam-jess-peking-visit.jpg"}
          maxHeight="315px"
        />
      </div>
      <p>
        Sam and Jess visited the{" "}
        <a href="https://pl.cs.pku.edu.cn/en/" target="_blank" rel="noreferrer">
          Programming Languages Lab at Peking University
        </a>{" "}
        and had a fantastic time. Thank you Professor Hu and all the members of
        the lab for your wonderful hospitality!
      </p>
    </div>,
  ],
  [
    "March 2024",
    <div>
      Cristina is recruiting a PostDoc in programming languages. Apply{" "}
      <a
        href="https://www.bristol.ac.uk/jobs/find/details/?jobId=337277"
        target="_blank"
        rel="noreferrer"
      >
        here
      </a>{" "}
      (deadline: 18th March)
    </div>,
  ],
  [
    "March 2024",
    <div>
      <a
        href="https://xingzhang-pku.github.io/"
        target="_blank"
        rel="noreferrer"
      >
        Xing Zhang
      </a>{" "}
      from Peking University is visiting us for 5 months. Welcome Xing!
    </div>,
  ],
  [
    "February 2024",
    <div>
      Jess traveled to Southampton to give a talk on Haskell game development to
      the student PL society.
    </div>,
  ],
  [
    "January 2024",
    <div>
      Alex Kavvos will be giving an invited talk at the ({" "}
      <a href="https://bctcs2024.github.io/" target="_blank" rel="noreferrer">
        British Colloquium for Theoretical Computer Science
      </a>{" "}
      ) in April, in Bath.
    </div>,
  ],
  [
    "January 2024",
    <div>
      We all had a great time at POPL'24, with many members of the group giving
      excellent talks!
    </div>,
  ],
  [
    "November 2023",
    <div>
      Paper ({" "}
      <a
        href="https://popl24.sigplan.org/details/POPL-2024-popl-research-papers/69/Ill-Typed-Programs-Don-t-Evaluate"
        target="_blank"
        rel="noreferrer"
      >
        Ill-Typed Programs Don't Evaluate
      </a>{" "}
      ) from the group accepted at POPL24.
    </div>,
  ],
  [
    "4-9 September 2023",
    <div>
      <div className="d-flex justify-content-center align-items-center">
        <ImageComponent
          alt={
            "A collage of Sam and Minh giving talks at ICFP and enjoying Seattle!"
          }
          src={"images/news/ICFP-collage.png"}
          maxHeight="315px"
        />
      </div>
      <p>
        Greetings from Seattle, where we had a successful ICFP'23!
        <ul>
          <li>
            Sam and Harry Goldstein presented their "Reflecting on Random
            Generation" distinguished paper (
            <a
              href="https://www.youtube.com/watch?v=ZQ_U-LANbc4&t=1312s"
              target="_blank"
              rel="noreferrer"
            >
              watch on YouTube
            </a>
            )
          </li>
          <li>
            Sam also presented "Embedding by Unembedding" (
            <a
              href="https://www.youtube.com/watch?v=dyRiPJM4DNw"
              target="_blank"
              rel="noreferrer"
            >
              watch on YouTube
            </a>
            )
          </li>
          <li>
            Minh presented "Effect Handlers for Programmable Inference" at
            Haskell Symposium (
            <a
              href="https://www.youtube.com/live/c6QAjzunnf8?t=11026"
              target="_blank"
              rel="noreferrer"
            >
              watch on YouTube
            </a>
            )
          </li>
        </ul>
      </p>
    </div>,
  ],
  [
    "August 2023",
    "Paper from the group (Reflecting on Random Generation) received a Distinguished Paper award at ICFP'23!",
  ],
  [
    "July 2023",
    "Alex Kavvos has won EPSRC funding to work on Language Embeddings for Proof Engineering. This project will be completed in collaboration with the University of Maryland, College Park.",
  ],
  [
    "July 2023",
    "<b>Contract Lenses: Reasoning about Bidirectional Programs via Calculation</b> was accepted to Journal of Functional Programming.",
  ],
  [
    "July 2023",
    "<b>Effect Handlers for Programmable Inference</b> accepted to Haskell Symposium 2023.",
  ],
  [
    "July 2023",
    <div>
      We now have a twitter! Give us a follow:{" "}
      <a
        href="https://twitter.com/PLRG_bristol"
        target="_blank"
        rel="noreferrer"
      >
        @PLRG_bristol
      </a>
    </div>,
  ],
  [
    "June-July 2023",
    <div>
      We are{" "}
      <a
        href="https://www.bristol.ac.uk/jobs/find/details/?jobId=316176&jobTitle=Lecturer%20in%20Programming%20Languages%20and%20Compilers"
        target="_blank"
        rel="noreferrer"
      >
        recruiting a lecturer in programming languages
      </a>
      . Please get in touch with Meng Wang (meng.wang@bristol.ac.uk) with
      enquires.
    </div>,
  ],
  [
    "June 2023",
    "Minh Nguyen was awarded a EPSRC Doctoral Prize Fellowship for the proposal Robust, Reusable Computational Models via Typed Functional Programming.",
  ],
  ["June 2023", "Steven Ramsay will serve on the POPL 2024 program committee."],
  [
    "May 2023",
    "<b>Embedding by Unembedding</b> and <b>Reflecting on Random Generation</b> accepted to ICFP 2023.",
  ],
  [
    "April 2023",
    "<b>Ownership guided C to Rust translation</b> accepted to CAV 2023.",
  ],
  [
    "2-6 April 2023",
    <div>
      Jess Foster and Celia Li attended{" "}
      <a
        href="https://www.cs.bham.ac.uk/~mhe/events/MGS23/"
        target="_blank"
        rel="noreferrer"
      >
        Midlands Graduate School 2023
      </a>{" "}
      at the University of Birmingham.
    </div>,
  ],
  [
    "March 2023",
    <div>
      Kazutaka Matsuda of Tohoku University visited us to present a talk on
      composable Elm-like Model-View-Update applications and collaborate on
      further "Embedding by Unembedding" research with Sam Frohlich, Jess
      Foster, and Meng Wang.
    </div>,
  ],
  [
    "17th March 2023",
    <div>
      <div className="d-flex justify-content-center align-items-center">
        <ImageComponent
          alt={"Sam selfie in Sweden"}
          src={"images/news/sam-sweden-mar-2023.jpg"}
          maxHeight="315px"
        />
      </div>
      <p>
        Sam presented her recent ICFP submission "Reflective Generators", which
        is joint work with Harry Goldstein and Benjamin C. Pierce from the
        University of Pennsylvania, at Chalmers University of Technology in
        Sweden, as part of her week long visit. (
        <a
          href="https://harrisongoldste.in/papers/drafts/icfp-2023-reflective.pdf"
          target="_blank"
          rel="noreferrer"
        >
          Preprint
        </a>
        ;{" "}
        <a
          href="https://docs.google.com/presentation/d/1172giR-MPnYMlZPJomf_UedY15_2gEFSOGQjsRl1DSU/edit?usp=sharing"
          target="_blank"
          rel="noreferrer"
        >
          Slides
        </a>
        )
      </p>
    </div>,
  ],
  [
    "March 2023",
    <div>
      We are recruiting a (senior) research associate in the area of programming
      languages and machine learning:{" "}
      <a
        href="https://www.bristol.ac.uk/jobs/find/details/?jobId=305015"
        target="_blank"
        rel="noreferrer"
      >
        Apply here
      </a>{" "}
      by 19 March
    </div>,
  ],
  [
    "21 Feb 2023",
    <div>
      <div className="d-flex justify-content-center align-items-center">
        <ImageComponent
          alt={
            "Sam (left) and Cristina (right) in front of Redmaids' High School"
          }
          src={"images/news/sam-cristina-redmaids.jpg"}
          maxHeight="315px"
        />
      </div>
      <p>
        Sam Frohlich and Cristina David went to Redmaids' High School to give an
        assembly and run a workshop about functional programming and fractals
        using CodeWorld.
      </p>
    </div>,
  ],
  [
    "January 2023",
    <div>
      Alex Kavvos served on the{" "}
      <a
        href="https://lics.siglog.org/lics23/"
        target="_blank"
        rel="noreferrer"
      >
        LICS 2023
      </a>{" "}
      programme committee.
    </div>,
  ],
  [
    "19 Jan 2023",
    "Minh Nguyen presented his PhD work to data scientists at The Alan Turing Institute.",
  ],
  [
    "November 2022",
    "Cristina David has won funding for a 3 year PostDoc from the Royal Society. We will start recruiting soon.",
  ],
  [
    "October 2022",
    "Steven Ramsay is one of the winners of the 2022 WhatsApp Privacy Aware Program Analysis for the proposal Scalable, static taint analysis for Core Erlang",
  ],
  ["October 2022", "Paper from the group accepted at POPL 2023"],
  [
    "June 2022",
    "Two new research posts are open in the group. Please get in touch if you are interested.",
  ],
  [
    "May 2022",
    "Cristina David's Royal Society University Research Fellowship has been extended for another three years. Also, she received funding for a research assistant.",
  ],
  ["February 2022", "Paper accepted at PLDI."],
  [
    "January 2022",
    <div>
      <VideoComponent src="https://www.youtube-nocookie.com/embed/Ov1HOMKn8t4" />
      <p>
        Roly Perera presented{" "}
        <a href="http://dynamicaspects.org/papers/popl22-final.pdf">
          Linked Visualisations via Galois Dependencies
        </a>{" "}
        (with Minh Nguyen, Tomas Petricek and Meng Wang) at POPL 2022.
      </p>
    </div>,
  ],
  [
    "January 2022",
    <div>
      <VideoComponent src="https://www.youtube-nocookie.com/embed/LGaTnxYcdm4" />
      <p>
        Sam Frohlich presented{" "}
        <a href="https://arxiv.org/pdf/2111.12420.pdf">
          CircuitFlow - A Domain Specific Language for Dataflow Programming
        </a>{" "}
        (with Riley Evans and Meng Wang) at PADL 2022.
      </p>
    </div>,
  ],
  [
    "January 2022",
    <div>
      <VideoComponent src="https://www.youtube-nocookie.com/embed/SUZ-eqprNg0" />
      <p>
        {" "}
        NingNing Xie presented{" "}
        <a href="https://xnning.github.io/papers/staging-with-class.pdf">
          Staging with Class
        </a>{" "}
        (with Matthew Pickering, Andres Loh, Nicolas Wu, Jeremy Yallop, and Meng
        Wang) at POPL 2022.
      </p>
    </div>,
  ],
  [
    "November 2021",
    <div>
      <VideoComponent src="https://www.youtube-nocookie.com/embed/z8uPHKOTx6s" />
      <p>
        Sam Frohlich is giving a series of lectures on embedded domain specific
        languages! Here's a lecture premier.
      </p>
    </div>,
  ],
  [
    "November 2021",
    <>
      Cristina David will serve on the{" "}
      <a href="https://conf.researchr.org/home/icse-2023">ICSE 2023</a> program
      committee. She's currently serving on the{" "}
      <a href="https://etaps.org/2022/esop">ESOP 2022</a> program committee.
    </>,
  ],
  ["September 2021", "Two papers from the group accepted at POPL 2022."],
  [
    "September 2021",
    <>
      Alex Kavvos has won the Distinguished Paper Award at{" "}
      <a href="https://icfp21.sigplan.org/">ICFP 2021</a> for the paper{" "}
      <a href="https://dl.acm.org/doi/10.1145/3473567">
        Client-Server Sessions in Linear Logic
      </a>{" "}
      (with Zesen Qian and <a href="https://cs.au.dk/~birke/">Lars Birkedal</a>
      ).
    </>,
  ],
  [
    "August 2021",
    <>
      <a href="https://min-nguyen.github.io/">Minh Nguyen</a> won the first
      place at the ACM Student Research Competition (ICFP) with Composable,
      Modular Probabilistic Models. Congratulations Minh!
    </>,
  ],
  [
    "July 2021",
    <>
      Alex Kavvos serves in the{""}
      <a href="https://popl22.sigplan.org/">POPL 2022</a>
      program committee.
    </>,
  ],
  ["June 2021", "Hanliang Zhang joins the group as a research assistant."],
  [
    "April 2021",
    <>
      Our PhD students are attending the{" "}
      <a href="https://staffwww.dcs.shef.ac.uk/people/G.Struth/mgs21.html">
        Midlands Graduate School
      </a>
      .
    </>,
  ],
  [
    "February 2021",
    <>
      We (PI Meng Wang; CoI Cristina David) have received funding from{" "}
      <a href="https://www.ncsc.gov.uk/">
        National Cyber Security Centre (NCSC)
      </a>{" "}
      to work on Verified Program Synthesis for Refactoring Rust Programs.
    </>,
  ],
  ["November 2020", "Webpage goes live!"],
];

export function createNews({ limit = null } = {}) {
  let finalNews = news;
  if (limit !== null) {
    finalNews = news.slice(0, limit);
  }

  // Make the dates bold:
  finalNews = finalNews.map((newsItem) => {
    newsItem[0] = <b>{newsItem[0]}</b>;
    return newsItem;
  });

  return [
    <ListComponent
      components={finalNews.map((sections) => (
        <HorizontalComponent
          components={sections}
          centerCols={[0]}
          colWidthOverrides={[2, 10]}
        />
      ))}
    />,
  ];
}
